function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icons/social/twitter");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/social/twitter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12,0 C5.38278261,0 0,5.38278261 0,12 C0,18.6172174 5.38278261,24 12,24 C18.6172174,24 24,18.6172174 24,12 C24,5.38278261 18.6172174,0 12,0 Z M17.8627826,9.66469565 C17.868,9.78782609 17.8711304,9.91304348 17.8711304,10.0387826 C17.8711304,13.8568696 14.9634783,18.2608696 9.64747826,18.2608696 C8.01547826,18.2608696 6.49565217,17.7824348 5.2173913,16.9622609 C5.44330435,16.9893913 5.67234783,17.0024348 5.9066087,17.0024348 C7.26104348,17.0024348 8.50747826,16.5412174 9.49565217,15.765913 C8.23095652,15.7429565 7.16452174,14.9055652 6.79565217,13.7587826 C6.97252174,13.7926957 7.15356522,13.8109565 7.34034783,13.8109565 C7.60382609,13.8109565 7.85947826,13.776 8.10104348,13.7092174 C6.78,13.4426087 5.784,12.276 5.784,10.8751304 C5.784,10.8626087 5.784,10.8506087 5.784,10.8386087 C6.17373913,11.0551304 6.61878261,11.1855652 7.09304348,11.2006957 C6.31669565,10.6815652 5.80747826,9.79773913 5.80747826,8.79495652 C5.80747826,8.2653913 5.9493913,7.76921739 6.19826087,7.3413913 C7.62417391,9.08973913 9.75391304,10.2401739 12.1554783,10.3612174 C12.105913,10.1493913 12.0798261,9.92921739 12.0798261,9.70278261 C12.0798261,8.10678261 13.3737391,6.81286957 14.9702609,6.81286957 C15.8013913,6.81286957 16.5521739,7.16347826 17.0791304,7.7253913 C17.7370435,7.596 18.3563478,7.35547826 18.9146087,7.02469565 C18.6991304,7.69878261 18.2405217,8.2653913 17.6431304,8.62330435 C18.2285217,8.55234783 18.7846957,8.39791304 19.3038261,8.16782609 C18.9166957,8.74747826 18.4267826,9.25721739 17.8627826,9.66469565 Z",
  id: "Shape",
  fill: "#FD8C8C"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.436d3680.svg";
export { ForwardRef as ReactComponent };